export class ResponseCache {
  Data: Date;
  Result: string;
  Success: boolean;

  constructor(data?: Partial<ResponseCache>) {
    Object.assign(this, data);
  }
}
